module.exports = __webpack_public_path__ + "img/fevend-product-page.ba389ecc.png";